import { Button } from '@luminara/ui-components';

const NoBankDetails = ({ handleSetBankDetailsFn }: { handleSetBankDetailsFn: () => void }) => {
  return (
    <div className="ml-10 mt-4">
      <p className="text-primary text-[16px] mb-6">No bank details have been set yet!</p>
      <Button size="md2" onClick={handleSetBankDetailsFn}>
        Set bank details
      </Button>
    </div>
  );
};

export default NoBankDetails;
